function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  fillRule: "nonzero",
  d: "M0 15h15v-.966h-.947v-8.16L8.81 4.41v9.608H8.1V0L.947 1.448v12.586H0V15zm11.905-7.87h.948v1.255h-.948V7.13zm0 2.237h.948v1.255h-.948V9.367zm0 2.237h.948v1.255h-.948v-1.255zM9.995 7.13h.947v1.255h-.947V7.13zm0 2.237h.947v1.255h-.947V9.367zm0 2.237h.947v1.255h-.947v-1.255zM5.953 2.672H6.9v1.255h-.947V2.672zm0 2.237H6.9v1.255h-.947V4.91zm0 2.22H6.9v1.256h-.947V7.13zm0 2.238H6.9v1.255h-.947V9.367zm-1.91-6.695h.946v1.255h-.947V2.672zm0 2.237h.946v1.255h-.947V4.91zm0 2.22h.946v1.256h-.947V7.13zm0 2.238h.946v1.255h-.947V9.367zM2.131 2.672h.947v1.255h-.947V2.672zm0 2.237h.947v1.255h-.947V4.91zm0 2.22h.947v1.256h-.947V7.13zm0 2.238h.947v1.255h-.947V9.367zm1.484 2.237h1.816v2.43H3.616v-2.43z"
});

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.52f183d2.svg";
export { ForwardRef as ReactComponent };